import React, { MouseEventHandler } from 'react';
import Markdown from 'react-markdown';

interface DiscardResultsFooterMarkdownProps {
	content: string;
	onClick: MouseEventHandler<HTMLButtonElement>;
}
const DiscardResultsFooterMarkdown: React.FC<DiscardResultsFooterMarkdownProps> = ({ content, onClick }) => {
	const customComponents = {
		code: ({ inline, node, children, ...props }: any) => {
			return (
				<button type="button" className="link-button" style={{ fontFamily: 'Roboto, sans-serif' }} onClick={onClick} {...props}>
					{children}
				</button>
			);
		}
	};

	return (
		<Markdown className="custom-markdown" components={customComponents}>
			{content}
		</Markdown>
	);
};

export default DiscardResultsFooterMarkdown;
